export default __webpack_public_path__ + "static/area_1-a1dad511d1d81164af34849490d9cac0.jpg";